/* eslint-disable import/prefer-default-export */

export const baseUrl = process.env.REACT_APP_BASE_URL;
export const socketUrl = process.env.REACT_APP_SOCKET_URL;
export const appEnv = process.env.REACT_APP_ENV;
